// axios
import axios from 'axios'
const baseURL = ""
let _axios = axios.create({
  baseURL: baseURL,
  headers: {
    dashboard:'light-taxipoint'
  }
  // You can add your headers here
})


_axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    // config.headers['Content-Type'] = 'application/json';
    return config;
  },
  error => {
    Promise.reject(error)
  });

export default _axios


